import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Clients from "./Clients";

import us from "../../assets/images/img/us2.jpg";

export default function About() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  return (
    <>
      <div id="scroll" className="section section__about">
        <div>
          <Clients />

          <div className="about">
            <div className="content slide-from-left">
              <h5>About us</h5>
              <h2 style={{ marginBottom: 30 }}>
                We combine expertise and innovation to create solutions that
                drive your strategic goals.
              </h2>
              <p style={{ marginBottom: 20 }}>
                At Genvix Tech, we know that a strong digital presence comes
                from smooth integration. From building your brand to creating
                custom software and digital solutions, we use smart design and
                real market knowledge. Our approach is based on data to make
                sure your technology connects with your audience and helps your
                business grow steadily.
              </p>
              <button
                onClick={() => (window.location.href = "/about-us")}
                className="btn blue"
              >
                more
              </button>
            </div>
            <div className="about__images slide-from-right">
              <img loading="lazy" src={us} alt="us" className="image__patryk" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
